export function calculateRiskScore(data) {
    let score = 0;

    // UAE Visa/Residency (10%)
    if (data.uae_visa === 'Yes') score += 0.5;

    // Define regions
    const GCCCountries = ['Bahrain', 'Kuwait', 'Oman', 'Qatar', 'Saudi Arabia', 'United Arab Emirates'];
    const EUCountries = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'];
    const USACountries = ['United States'];
    const UAECountries = ['United Arab Emirates'];

    // Nationality Score (15%)
    const highRiskNationalities = ['Iran, Islamic Republic Of', 'Korea, Democratic People\'S Republic of', 'Sudan', 'Syrian Arab Republic']; // Example high-risk countries

    let nationalityScore = 0;
    data.nationalities.forEach(nat => {
        if (GCCCountries.includes(nat) || EUCountries.includes(nat) || USACountries.includes(nat) || UAECountries.includes(nat)) {
            nationalityScore = Math.max(nationalityScore, 0.75);
        } else if (highRiskNationalities.includes(nat)) {
            nationalityScore = 0;
        } else {
            nationalityScore = Math.max(nationalityScore, 0.3);
        }
    });
    score += nationalityScore;

    // Business Location (10%)
    if (data.jurisdiction === 'Mainland') score += 0.5;
    else if (data.jurisdiction === 'Free Zone') score += 0.25;
    else if (data.jurisdiction === 'Offshore' || data.jurisdiction === 'Not Sure') score += 0;

    // Business Activity Risk Level (20%)
    const lowRiskActivities = ['it', 'consulting', 'e_commerce'];
    const mediumRiskActivities = ['trading', 'general_services'];
    const highRiskActivities = ['crypto', 'real_estate', 'financial_services'];

    if (lowRiskActivities.includes(data.business_activity)) score += 1;
    else if (mediumRiskActivities.includes(data.business_activity)) score += 0.5;
    else if (highRiskActivities.includes(data.business_activity)) score += 0;

    // Expected Annual Turnover (15%)
    if (data.annual_turnover === 'above_10m') score += 0.75;
    else if (data.annual_turnover === '1m_to_10m') score += 0.5;
    else if (data.annual_turnover === '500k_to_1m') score += 0.3;
    else if (data.annual_turnover === 'less_than_500k') score += 0;

    // Deposit Amount (15%)
    if (data.deposit_amount === 'above_100k') score += 0.75;
    else if (data.deposit_amount === '50k_to_100k') score += 0.5;
    else if (data.deposit_amount === '25k_to_50k') score += 0;

    // Operating Countries (15%)
    let countryScore = 0;
    data.countries.forEach(country => {
        if (GCCCountries.includes(country) || EUCountries.includes(country) || USACountries.includes(country) || UAECountries.includes(country)) {
            countryScore = Math.max(countryScore, 0.75);
        } else if (highRiskNationalities.includes(country)) {
            countryScore = 0;
        } else {
            countryScore = Math.max(countryScore, 0.3);
        }
    });
    score += countryScore;

    // Ensure score is within 0-5 range
    return Math.min(5, Math.max(0, parseFloat(score.toFixed(1))));
}